module.exports = __webpack_public_path__ + "static/media/6.d4f319fa.jpg";